import type { ReactNode } from 'react';

/** 약관·방침 공용 레이아웃. 조 제목은 h2, 항목은 번호 없는 문단·목록으로 둔다. */
export function LegalDoc({ children }: { children: ReactNode }) {
  return <div className="mt-6 space-y-8 text-sm leading-relaxed text-gray-800">{children}</div>;
}

export function Article({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="text-base font-bold text-gray-900">{title}</h2>
      <div className="mt-2 space-y-2">{children}</div>
    </section>
  );
}

export function List({ items }: { items: ReactNode[] }) {
  return (
    <ul className="list-disc space-y-1 pl-5">
      {items.map((it, i) => (
        <li key={i}>{it}</li>
      ))}
    </ul>
  );
}
